import TenantInvitationTable from "@/v2-backoffice-client/tenant/invitation/TenantInvitationTable"
import { useTenantInvitationQuery } from "@/v2-backoffice-client/tenant/invitation/tenant.invitation.query"

export type TenantInvitationProps = {
  tenantId: number
}

function TenantInvitation(props: TenantInvitationProps) {
  const { tenantId } = props

  const { data, loading, error, refetch } = useTenantInvitationQuery({
    variables: { tenantId },
  })

  const invitations = data?.getTenantInvitations || []

  return (
    <TenantInvitationTable
      tenantId={tenantId}
      invitations={invitations}
      isLoading={loading}
      error={error}
      onRefresh={refetch}
    />
  )
}

export default TenantInvitation
